export enum GlobalEvents {
  SnackBar = 'SnackBar',
  Dialog = 'Dialog',
  FirstSignIn = 'FirstSignIn'
}
